import React from "react"
import ReactDOM from 'react-dom'
import _, { forEach } from 'lodash'
import Slider from 'react-slick'
import { StickyContainer, Sticky } from 'react-sticky'
import SliderSettings from '~/tools/slickSliderSettings'
import { splitEventsIntoDays, daysDifference } from "~/tools/date-utils";
import makeSticky from '~/tools/sticky'
import ListItemDetailed from '~/components/ListItemDetailed'

import './style.scss'

class LiveSchedule02 extends React.Component {
	state = {
		data: this.props.data.contentData.filter( item => item.gist.scheduleEndDate > Date.now() ),
		isLive: {},
		currentIndex: 0,
		currentSlide: 0,
		updateSlider: true,
		topOffset: null,
		isMobile: false
	}
	componentDidMount(){
		window.addEventListener('scroll', this.handleScroll)
		window.addEventListener('resize', this.handleResize)
		this.setTopOffset()
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('scroll', this.handleScroll);
	}
	trimDay = (day) => {
		return day.slice(0, 3)
	}
	handleResize = () => {
		if(window.innerWidth < 550){
			this.setState({isMobile: true})
		}else{
			this.setState({isMobile: false})
		}
		this.setTopOffset()
	}
	setTopOffset = () => {
		console.log('setoffset')
		let topOffset = 0;
		if (this.dateSliderContainer) makeSticky(this.dateSliderContainer)
		var containers = document.querySelectorAll('.sticky-header')

		forEach(containers, (stickyContainer) => {
			topOffset += stickyContainer.clientHeight
		})
		this.setState({topOffset: topOffset})
	}
	scrollTo = (ref, index) => {
		this.setState({updateSlider: false}, () => {
			const domeNode = ReactDOM.findDOMNode(this[ref])
			const scrollBy = -(this.state.topOffset - 2)
			domeNode.scrollIntoView({block: "start"})
			window.scrollBy(0, scrollBy);
			// window.scrollTo({
			// 	top: domeNode.offsetTop - 98,
			// 	// behavior: "smooth"
			// })
			setTimeout(() => this.setState({currentIndex: index, updateSlider: true}))
		})
	}
	handleScroll = (event) => {
		this.setTopOffset()
		if (this.state.updateSlider){
			if(this.sliderTimeout){
				clearTimeout(this.sliderTimeout);
			}
			this.sliderTimeout = setTimeout(() => {
				let currentIndex = 0
				const dateGroups = document.querySelectorAll(".live-event-date")
				dateGroups.forEach((dateEl, index) => {
					if(dateEl.offsetTop <= this.state.topOffset){
						currentIndex = index
					}
				})
				this.updateDateSlider(currentIndex)
			}, 400);
		}
	}
	updateDateSlider(currentIndex){
		if(this.state.currentIndex !== currentIndex){
			let currentSlide = Math.floor(currentIndex/7)*7;
			this.dateSlider.slickGoTo(currentSlide);
			this.setState({
				currentIndex: currentIndex,
				currentSlide: currentSlide
			})
		}
	}
	render(){
		const data = this.state.data || []
		let weeksToShow = Math.ceil(daysDifference(new Date(), new Date(this.props.data.contentData[this.props.data.contentData.length-1].gist.scheduleStartDate))/7);
		if(weeksToShow < 1) weeksToShow = 1;
		if (weeksToShow > 3) weeksToShow = 3;
		const daysEvents = splitEventsIntoDays(data, weeksToShow)
		const columns = {
			desktop: 7,
			mobile: 7,
			tablet: 7,
			ott: 7,
		}
		const sliderSettings = new SliderSettings(columns)
		return (
			<div className="live-schedule-02" ref={el => this.dateSliderContainer = el}>
				<div 
					className={`date-slider-container`} 
				>
					<div 
						className="date-slider"
						style={{
							backgroundColor: _.get(window.settings, 'brand.general.backgroundColor'),
						}}
					>
						<div className="live-schedule-title">
							Live Schedule
						</div>
						<Slider
							ref={el => this.dateSlider = el}
							dots={true}
							infinite={false}
							arrows={ true }
							slidesToShow={ sliderSettings.slidesToShow }
							slidesToScroll={ 7 }
							responsive={ sliderSettings.responsiveBreakpoints } >
							{daysEvents.map((dayEvent, key) => (
								<div key={key} className={`dayevent-label-container`} onClick={() => this.scrollTo(`dayevent-label-${key}`, key)}>
									<div className={`dayevent-label`} style={key === this.state.currentIndex ? this.activeStyle : {}}>
										<span className={`date-label`}>
											{dayEvent.month} {dayEvent.date}
										</span>
										<span className={`day-label`}>
											{`${this.state.isMobile ? this.trimDay(dayEvent.day) : dayEvent.day}`}
										</span>
									</div>
								</div>
							))}
						</Slider>
					</div>
				</div>
				<div className={`live-event-container`}>
					{
						daysEvents.map((event, index) => (
							<StickyContainer key={index} ref={el => this[`dayevent-label-${index}`] = el}>
								<Sticky topOffset={-this.state.topOffset} relative={false}>
								{
									({ style, isSticky }) => (
										<div 
											className="live-event-date"
											style={{
												...style,
												zIndex: 1,
												top: isSticky ? this.state.topOffset : 0,
												backgroundColor: isSticky ? _.get(window.settings, 'brand.general.backgroundColor') : 'transparent',
												borderBottom: `1px solid #4a4a4a`
											}}
										>
											{this.trimDay(event.day)}, {event.month} {event.date}
										</div>
									)
								}
								</Sticky>
								{
									event.events && (
										<div className={`detailed-item-list`}>
										{
											event.events.map(item => 
												<ListItemDetailed 
													key={item.gist.id}
													addToCalender={true} 
													showTimer={true} 
													showBookmark = {false}
													item={item}
													onLive={(id) => {
														this.setState({
															isLive: {
																[id]: true
															}
														})
													}}
													showPlayIcon={this.state.isLive[item.gist.id]}
												/>
											)
										}
										</div>
									)
								}
								{
									!event.events && (
										<div className="no-items">
											No Classes Scheduled
										</div>
									)
								}
							</StickyContainer>
						))
					}
				</div>
			</div>
		)
	}
	get activeStyle(){
		return {
			backgroundColor: _.get(window.settings, "brand.navigation['link--active'].textColor"),
			color: _.get(window.settings, "brand.navigation['link'].textColor"),
		}
	}
}

export default LiveSchedule02;